export const LAST_ACTIVITY_LABELS: Record<string, string> = {
  never: 'Never contacted',
  today: 'Today',
  yesterday: 'Yesterday',
  stale7: 'Inactive 7+ days',
  stale15: 'Inactive 15+ days',
  stale20: 'Inactive 20+ days',
  stale30: 'Inactive 30+ days',
  stale60: 'Inactive 60+ days',
  stale90: 'Inactive 90+ days',
};

export const LAST_ACTIVITY_OPTIONS = Object.entries(LAST_ACTIVITY_LABELS).map(
  ([value, label]) => ({ value, label })
);
